import { PlotCoreObject } from '@core_n/asp/PlotCoreObject';
import { IObjectsPool } from '@core_n/asp/interfaces';

export class PlotObject extends PlotCoreObject {

  doppler: number; // m/s
  dopplerAccuracy: number; // m/s
  spinRate: number; // Hz

  constructor(objectsPool: IObjectsPool, sensorID: number, sensorPlotID: number, correlated: boolean) {
    super(objectsPool, sensorID, sensorPlotID, correlated);
  }
  
  protected postHandleMsg(msgObj: any) {
    if (msgObj.doppler != null)
      this.doppler = msgObj.doppler;
    if (msgObj.dopplerAccuracy != null)
      this.dopplerAccuracy = msgObj.dopplerAccuracy;
    if (msgObj.spinRate != null)
      this.spinRate = msgObj.spinRate;
  }

}

